'use strict';

const aos = {
    init: function (){
        // Configuration de l'observer (optionnel)
        const config = {
            threshold: 0.2
        };
    
        // Instanciation de l'intersectionObserver pour le lazy loading
        let observer = new IntersectionObserver(function (entries, self) {
            // Pour chaque entrée ciblée
            entries.forEach(entry => {
                // L'API Javascript vérifie que l'entrée existe...
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    // L'image est chargée, l'API peut s'arrêter jusqu'à la prochaine, etc.
                    self.unobserve(entry.target);
                }
            });
        }, config);
    
        // Sélectionne les images et lance l'observer asynchrone
        const items = document.querySelectorAll('[data-in-view], [data-left-in-view], [data-right-in-view]');
        items.forEach(item => {
            // Observation des images à charger au fur et à mesure
            observer.observe(item);
        });
    },
}

export default aos;


// WEBPACK FOOTER //
// ./src/scripts/anims/appear-on-scroll.js